import { Outlet } from 'react-router-dom'

const Assessment = () => {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default Assessment
